import PropTypes from "prop-types";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Tab from "../components/navigation/Tab.js";
import AdminLayout from "./AdminLayout.js";

const AdminEventLayout = ({ eventId, children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const labels = [
    "Informações do Evento",
    "Inscrições",
    "Avaliação",
    "Questionários de Satisfação",
  ];
  const urls = ["/", "/tickets", "/quizzes", "/surveys"];

  // find from index 1 because first index will always return true ("/"). besides, +1 will make it so that -1 --> 0
  const selectedTab =
    urls.slice(1).findIndex((url) => location.pathname.includes(url)) + 1;

  return (
    <AdminLayout title="Eventos Online">
      {eventId && (
        <Tab
          labels={labels}
          selected={selectedTab}
          onSelectTab={(tab) =>
            navigate(`/admin/events/${eventId}/edit${urls[tab]}`)
          }
        />
      )}
      {children}
    </AdminLayout>
  );
};

AdminEventLayout.propTypes = {
  eventId: PropTypes.string.isRequired,
};

export default AdminEventLayout;
